export const CREATE_CARD_ORDER_WIZARD_NAMESPACE =
  'meal-voucher-create-card-order';

export const CREATE_CARD_ORDER_STEPS = {
  SELECT_EMPLOYEES: 'select-employees',
  CONFIRM: 'confirm',
  RECAP: 'recap',
} as const;

export const ELIGIBLE_EMPLOYEES_FILTERS_NAMESPACE =
  'hr/meal-voucher-card-order/eligible-employees';

export const ELIGIBLE_EMPLOYEES_REPLACEMENT_FILTERS_NAMESPACE =
  'hr/meal-voucher-card-order/eligible-employees-replacement';

export const CONFIRM_STEP_PAGE_SIZE = 25;

export const REPLACEMENT_MAX_SELECTABLE_EMPLOYEES = 1;
